import Api from "./Api";

const endpoint = "/files";
export default {
    get(params) {
        var usedParams = {};
        return Api.fetchData(endpoint, usedParams);
    },
    getFile(id, params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(endpoint + "/" + id, usedParams, true, true);
    },
    post(file) {
        return Api.uploadFile(endpoint, file);
    }
};
